import { Injectable } from '@angular/core';
import { GwcApiConnService } from './gwc-api-conn.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class GwcApiCreditsService {


    constructor(
        private _connService: GwcApiConnService
    ) {

    }   

    check(credit_code: string) {
        return this._connService.request('GET', ['Credit', credit_code, 'check']);
    }




    // get(): Observable<Credit[]> {
    //     return this._connService.request('GET', 'Credit') as Observable<Credit[]>
    // }

    // get_details(credit_id: string) {
    //     return this._connService.request('GET', ['Credit', credit_id]);
    // }

    // create(payload: any) {
    //     return this._connService.request('POST', 'Credit', undefined, payload)
    // }

    // update(credit_id: string, payload: any) {
    //     return this._connService.request('PUT', ['Credit', credit_id], undefined, payload);
    // }



}